export default {
    id:'pt',
    wellcome: {
        our_mission:'Nossa missão',
        our_vission: 'Nossa visão',
        our_values: 'Nossos valores',
        link: 'https://www.goodhope.org.pe/quienes-somos',
        more_information: 'Mais informações', 
        vission: 'Ser uma rede de saúde reconhecida pela excelência na assistência médico-hospitalar, prevenção e promoção de um estilo de vida saudável, integrando fé e ciência',
        mission: 'Servir, curar e salvar, promovendo a saúde física, mental, social e espiritual, seguindo o exemplo de cristo',
        values: ['Amor a Deus e ao Próximo', 'Respeito aos Princípios Bíblicos', 'Integridade, Ética e Transparência', ' Excelência em Servir', 'Acolhimento, Cuidado e Compaixão', 'Competência Técnica com Criatividade e Inovação', 'Sustentabilidade Financeira, Social e Ambiental'],
        slogan: 'Servir, Curar e Salvar',
        sloganLarge: ['Acredita na vida']
      
    },
    login: {
        user: 'Usuario',
        userPlaceholder: 'Meu usuario',
        password: 'Senha',
        passwordPlaceholder: 'Meu senha',
        button: 'Entrar',
        quest: '¿Você esqueceu sua senha?',
        forgotMessage: 'Entre em contato com Adventist Health',
        logoAdv : '',
        logoRed: '',
        exit:'Sair'
    },
    loading:{
        text: 'Procurando informações'
    },

    common: {
        save: 'Salvar',
        loading: 'Carregando',
        name: 'Nome',
        description: 'Descrição',
        error: 'Erro',
        type: 'Tipo',
        user: 'Usuário',
        option: 'Opção',
        options: 'Opções',
        option_short: 'Opç',
        leadership: 'Liderança',
        kpi: 'Indicador',
        kpis: 'Indicador | Indicadores',
        company: 'Empresa',
        plan: 'Planejamento',
        sector: 'Setor',
        period: 'Período',
        state: 'Estado',
        agreement : 'Acordo',
        group: 'Perspectiva',
        init: 'De',
        end: 'Para', 
        observation: 'Observação',
        comment: 'Comentário',
        code: 'Código',
        new: 'Novo',
        add: 'Agregar',
        edit: 'Editar',
        agreements: 'Acordo | Acordos',
        quality: 'Qualidade',
        control_managment: 'Gestão de controle',
        provider: 'Fornecedor',
        client: 'Cliente' ,
        date: 'Data',
        clean: 'Limpar',
        delete: 'Excluir',
        defuse: 'Desarmar',
        active: 'Ativar',
        total: 'Total',
        all: 'Todos',
        report: 'Relatório',
        download: 'Baixar',
        measure: 'medição',
        history: 'Registro',
        back:'Retornar',
        approve: 'Aprovar',
        yes: 'Sim',
        no: 'Não',
        points: 'Puntos',
        kpi_xs: 'KPI',
        search: 'Pesquiçar',
        created: 'Criado'
    },

    kpi:{
        upload_evidence: 'Carregar evidências',
        upload_file: 'Carregar arquivo',
        upload_see : 'veja evidências',
        upload_name : 'Nome do arquivo',
        attachment_file: 'Arquivos anexados',
        not_avariable: 'Não disponível',
        upload_set_file: 'Por favor subir un archivo',
        upload_set_name: 'Por favor ingresar un nombre',
        upload_ok : 'Se guardó el archivo',
        upload_ko: 'Error al guardar el archivo',
        upload_delete_ok: 'Se eliminó el archivo',
        upload_delete_ko: 'Error al eliminar archivo',
        upload_download_ko: 'Error al descargar archivo',

        stereotypes:'Estereótipos',
        acreditations: 'Acreditações',


        measure: 'insira a medição',
        write: 'Insira sua análise aqui',
        measure_ko: 'Não atingiu a meta',
        measure_ok: 'Você atingiu a meta',
        measure_value: 'Alcançado',
        analysis: 'Análise',
        formula: 'Fórmula',
        level: 'Nível',
        kpi: 'Indicador',
        goal: 'Meta',
        result: 'Alcançado',
        percent: '% Conformidade',
        method: 'Método',
        check: 'Avaliação',
        checker: 'Avaliador',
        checked: 'Avaliado',
        history: 'Registro',
        history_title: 'Histórico de alterações',
        commentary: 'Comentário',
        measure_null: 'Ainda não temos dados'

    },

    sector: {
        sector: 'Setor',
        search: 'Encontre um setor',
        form: 'Dados do setor',
        children: 'Setores associados',
        children_ko: 'Não tem setores associados',
        users: 'Usuarios relacionados',
        type: 'Tipo de setor',
        select_please: 'Selecione um setor'
    },

    plan: {
        title:'PDCA-5W2H-OKR',
        complete: 'Não há pendências para este setor',
        doing: 'Em andamento',
        action_plan: 'Plano de ação',
        kpi: 'Indicador (Indicador KPI Geral)',
        kpi_goal: 'Meta KPI',
        kr: 'KR - Resultado principal',
        kr_actual: 'R Atual',
        kr_goal: 'Meta KR',
        kr_days: 'Tempo (dias)',
        kr_result: 'Resultado',
        reason: 'Por que ele faria isso? ',
        reason_description: 'Identifique o início do problema',
        reason_other: 'Outra razão',
        plan_how_kr: 'Como o KR ​​conseguirá isso?',
        plan_what: 'O que será feito?',
        plan_how: 'Como isso será feito?',
        plan_who: 'Quem fará isso?',
        plan_when: 'Quando isso será feito?',
        plan_where:  'Onde será feito?',
        plan_cost: 'Quanto vai custar?',
        plan_when_description: 'insira o número de dias que será realizado',
        do_init: 'Data de início',
        do_end: 'Data final',
        check_advance: 'Tipo de adiantamento',
        check_pass: 'Avaliações anteriores',
        collaboration: 'Colaboração',
        collaboration_sector: 'Setor para comunicar',
        collaboration_past: 'Comunicações passadas',
        act: 'Comentários para a área de qualidade',
        do_not:'Nao executado',
        complete_yes: 'Finalizado',
        complete_no: 'Terminou sem atingir a meta',
        progress: 'Em andamento',
        bureaucracy: 'Burocracia no processo',
        training: 'Falta de treinamento',
        impact: 'Impacto de outra área',
        infra: 'Infraestrutura'

    },

    risk: {
        type: 'Tipo de riesgo por el incumplimiento del indicador',
        risk: 'riesgo en la experiencia del paciente por el incumplimiento del indicador',
        impact: 'Impacto por incumplimiento del indicador',
        category: 'Categoría ' ,
        operational: 'Criterio operacional',
        legal: 'Criterio regulatorio',
        finance:'Criterio financiero'
    },

    ose: {
        kpi: 'Datos del indicador',
        type: 'Tipo de indicador',
        class: 'Clasificación OSE'
    },

    checklist: {
        nothing: 'No hay indicadores tipo CHECKLIST para este sector',
        new: 'Nuevo checklist'
    },

    review : {
        result: 'Resultado',
        controller: 'Controller',
        feedback: 'Evaluador',
        complete: 'Cumplió la meta',
        evidence: 'Evidencia',
        analysis: 'Análisis',
        kpi_sector: 'INDICADORES RELACIONADOS POR SETORES'
    },
    
    agreement: {
        as_provider: 'Meus acordos com outros fornecedores',
        as_client: 'Meus acordos',
        motive: 'Motivo do contrato',
        time: 'Prazo',
        preview: 'Pré-requisito',
        my: 'Meu acordo',
        sign: 'Assinado em ',
        complete: 'Cumpriu o acordo',
        complete_ko: 'Motivo da não conformidade',
        confirm_message: 'Assinado em  {date} pelo usuário {user} ',
        confirm_title: 'Confirmar acordo',
        new:'Novo acordo',
        edit: 'Editar acordo',
        approve: 'Aprovar acordo',
        review: 'Avaliação do acordo',
        confirm_delete: 'Tem certeza de que deseja excluir este contrato?',
        period_out: 'Período fechado'
    },

    report : {
        title: 'Painéis',
        dashboard: {
            title: 'Dashboard',
            group_point : 'Distribuição de pontuação por perspectiva',
            stereotype_point: 'Distribuição de pontuação por estereótipo',
            total_point: 'Total de pontos',
            percent: 'Porcentagem alcançada',
            kpi_detail: 'Lista detalhada de indicadores',
            average: 'Média'
        },
        ranking : {
            title: 'Ranking',
            unit: 'Unidad administrativa'
        },
        history: {
            title: 'Histórico'
        },
        plan: {
            title: 'Planos'
        },
        accreditation:{
            title: 'credenciamento'
        },
        ose: {
            title: 'OSE'
        },
        risk: {
            title: 'Risco'
        },
        erp: {
            title : 'ERP'
        }
    },

    config: {
        title: 'Configurações',
        company:'Configuração da empresa',
        basic: 'Configurações básicas',
        menu : {
            user: 'Usuários',
            plan: 'Planejamento',
            objetive: 'Tipo de objetivos',
            sectorType: 'Tipo de setores',
            leadership: 'Liderança',
            smtp: 'SMTP',
            sectors: 'Setores',
            groups: 'Perspectivas',
            periods: 'Períodos',
            stereotypes : 'Estereótipos',
            blocks: 'Fechaduras',
            integrations: 'Integrações',
            template: 'Modelos',
            kpi: 'Indicadores',
            objetives: 'Objetivos',
            ranking: 'Cálculos'
        }
    },
    menu: {
        operational: 'Análise Operacional',
        tactic: 'Análise Tática',
        strategic: 'Análise Estratégica',
        plan: 'PDCA-5W2H-OKR',
        process: 'Processos',
        map: 'Mapa Estratégico',
        risk: 'Gestão de Risco e Experiência',
        ose: 'OSE',
        epr: 'EPR-SCS',
        checklist: 'Checks',
        advance: 'Avanços',
        review: 'Avaliar',
        agreement: 'Acordos',
        report: 'Painéis',
        config: 'Configurações'
    }
}


